import React, {useState, useEffect} from 'react';
import Modal from '../../components/modal/Modal';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import TermsAndCondtion from '../../core/terms-condtion';
import {
  otpData,
  errorInPhonenumber,
  phoneNumberIsloading,
  fetchOtp,
} from '../../redux/otpContainerSlice';
import {Otpinput} from './Otpinput';
import OtpTnC from './Otptnc';
import rightArrow from './../../assets/images/right_arrow_btn.svg';
import cogoToast from 'cogo-toast';
import ErrorToast from '../../components/notifications/ErrorToast';
const Otpbox: React.FC = () => {
  const phonenumberHasErrorMessage = useAppSelector(errorInPhonenumber);
  const phonenumberHasLoaded = useAppSelector(phoneNumberIsloading);
  const otp = useAppSelector(otpData);
  const [mobileNum, setmobileNum] = useState('');
  const dispatch = useAppDispatch();
  const [otpScreenStatus, setOtpScreenStatus] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState(false);
  const [tnc, setTnc] = useState(true);
  const [sendOTPButton, setsendOTPButton] = useState(false);
  const [timer, setShowTimer] = useState(32);
  const [displayTimer, setDisplayTimer] = useState(false);
  const [resentButtonClicked, setResetButtonClicked] = useState(false);

  const enableMobileInput = useAppSelector(
    state => state.globalReducer.enableMobileInput,
  );
  let timeInterval = 0;
  let count = 12;

  function showTimer() {
    setTimeout(() => {
      setDisplayTimer(true);
    }, 2000);

    timeInterval = window.setInterval(() => {
      if (timer === 0) {
        return;
      }
      count--;
      setShowTimer(prevTime => {
        console.log(prevTime);
        if (prevTime === 0) {
          console.log(prevTime);
          clearInterval(timeInterval);
          setsendOTPButton(false);
          return prevTime;
        }
        return prevTime - 1;
      });
    }, 1000);
  }
  useEffect(() => {
    if (resentButtonClicked === true) {
      //console.log('call');
      showTimer();
    }
  }, [resentButtonClicked]);
  const handleOnResend = () => {
    setResetButtonClicked(true);
    setsendOTPButton(true);
    setShowTimer(32);
    setDisplayTimer(false);
    showTimer();
    onResend();
  };

  useEffect(() => {
    if (otp != null && phonenumberHasLoaded === false) {
      ///sssjs
    }
    if (phonenumberHasErrorMessage != '' && phonenumberHasLoaded === false) {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong, Please try again."
        />,
        {
          hideAfter: 4,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [phonenumberHasErrorMessage, phonenumberHasLoaded, otp]);

  const inputNumberhandler = (e: {
    target: {value: React.SetStateAction<string>};
  }) => {
    ///    console.log(e.target.value.toString().charCodeAt(0));
    // if (isNaN(parseInt(e.target.value.toString()))) {
    //   return;
    // }
    setsendOTPButton(false);
    if (e.target.value.length <= 10) {
      setmobileNum(e.target.value);
    }
  };
  const onResend = () => {
    dispatch(fetchOtp(mobileNum));
    setsendOTPButton(false);
  };
  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setOtpScreenStatus(true);
    setDisableButton(true);
    setsendOTPButton(true);
    setTnc(false);
    //console.log(mobileNum);
    dispatch(fetchOtp(mobileNum));
    // showTimer();
  };
  return (
    <div className=" font-roboto font-normal text-black text-center text-base grid place-items-center">
      <div>
        <form onSubmit={handleSubmit}>
          <div className="bg-blue_four border-light_blue border flex h-12 items-center mt-4 py-2 rounded-lg w-full">
            <input
              className="bg-blue_four  border-b-0 border-l-0 border-r-1 border-t-0 rounded-l-lg text-black text-center w-14"
              type="text"
              value="+91"
              disabled
            />
            <input
              value={mobileNum}
              onKeyDown={e =>
                (e.keyCode === 69 || e.keyCode === 190 || e.key == '-') &&
                e.preventDefault()
              }
              min="1"
              onChange={inputNumberhandler}
              type="number"
              disabled={enableMobileInput}
              placeholder="Enter phone number"
              className="bg-blue_four border border-l-0 border-none flex-1 focus:outline-none font-roboto px-2 w-28"></input>

            <button
              type="submit"
              className="focus:outline-none font-bold h-12 normal primary arrow rounded-r-lg text-white w-12 flex items-center justify-center"
              disabled={mobileNum.length < 10 || sendOTPButton}>
              <img src={rightArrow} alt="Phone number" />
            </button>
          </div>
        </form>

        <p className="w-full text-xxs text-black text-center mt-1 leading-4">
          A 4 digit OTP will be sent via SMS to verify your number
        </p>
        {otpScreenStatus ? (
          <Otpinput
            tokenData={otp}
            phoneNumber={mobileNum}
            onResend={onResend}
            onOpenTnCModel={() => {
              setIsModelOpen(true);
            }}
            sendOTPButton={sendOTPButton}
          />
        ) : null}
        {tnc ? (
          <OtpTnC
            classes="mt-8"
            openTnCModal={() => {
              setIsModelOpen(true);
            }}
          />
        ) : (
          ''
        )}
      </div>
      {isModelOpen && (
        <Modal
          title="Terms And Conditions"
          isVisible={isModelOpen}
          onModalClosed={() => {
            setIsModelOpen(false);
          }}>
          <TermsAndCondtion />
        </Modal>
      )}
    </div>
  );
};
export default Otpbox;
